import React from 'react';
import { IconButton } from '@atlaskit/button/new';
import ChangesIcon from '@atlaskit/icon/core/changes';
import { Stack, Inline, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import { useParticipantListDragAndDrop } from '../../controllers/drag-and-drop/participant-list';
import {
	useActiveParticipants,
	useInactiveParticipants,
	useStandupStore,
} from '../../controllers/store';
import { ParticipantItem } from './item';
import messages from './messages';

export const PARTICIPANT_LIST_TEST_ID = 'rituals.standups.participant.list';

export const ParticipantList = () => {
	const { formatMessage } = useIntl();
	const activeParticipants = useActiveParticipants();
	const inactiveParticipants = useInactiveParticipants();
	const [, { shuffleParticipants }] = useStandupStore();

	useParticipantListDragAndDrop();

	return (
		<Stack space="space.050" testId={PARTICIPANT_LIST_TEST_ID}>
			<Inline alignBlock="center" space="space.050" xcss={subheadingStyles}>
				{formatMessage(messages.upNextNonfinal)}
				<IconButton
					appearance="subtle"
					// TODO: can't use legacy icon due to ratcheting, add @atlaskit/icon/glyph/bitbucket/compare to @atlassian/icon-lab
					icon={ChangesIcon}
					label={formatMessage(messages.shuffleParticipantsNonfinal)}
					isTooltipDisabled={false}
					onClick={shuffleParticipants}
				/>
			</Inline>
			<Stack>
				{activeParticipants.map((participant) => (
					<ParticipantItem
						key={participant.id}
						id={participant.id}
						name={participant.name}
						avatar={participant.avatar}
						status={participant.status}
					/>
				))}
				<ParticipantItem
					key="unassigned"
					id="unassigned"
					name={formatMessage(messages.unassignedNonfinal)}
					status="unassigned"
				/>
			</Stack>
			{!!inactiveParticipants.length && (
				<>
					<Inline xcss={subheadingStyles}>{formatMessage(messages.skippedNonfinal)}</Inline>
					<Stack>
						{inactiveParticipants.map((participant) => (
							<ParticipantItem
								key={participant.id}
								id={participant.id}
								name={participant.name}
								avatar={participant.avatar}
								status={participant.status}
							/>
						))}
					</Stack>
				</>
			)}
		</Stack>
	);
};

const subheadingStyles = xcss({
	font: token('font.heading.xxsmall'),
	lineHeight: token('space.300'),
});
